<template>
  <div class="flat-index">
    <div v-if="isDianDianHome" class="fi-mobile">
      <fi-header-mobile :is-mark="oMark"></fi-header-mobile>
      <div class="banner">
        <div class="banner-main">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide>
              <div class="ht">
                <h2>点点商城</h2>
                <hr>
              </div>
              <div>
                <p>年轻人的in生活指南</p>
              </div>
              <span>点一点，汇集时尚潮物，甄选全网低价尖货。 众安保险保障账户安全，为购物保驾护航。</span>
              <div class="pic"><img src="../assets/images/flat/mobile/mb-1.png" /></div>
            </swiper-slide>

            <!-- Optional controls -->
<!--            <div class="swiper-pagination my-swiper-pagination" slot="pagination"></div>-->
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
          </swiper>
        </div>
      </div>
      <div @click="downloadMobile" class="download-btn">立即下载</div>
      <div class="home-icon"></div>
      <div class="jy-list">
        <ul>
          <li>
            <div class="bg"></div>
            <div class="bg"></div>
          </li>
          <li>
            <div class="bg"></div>
            <div class="bg"></div>
          </li>
        </ul>
      </div>
      <div class="adv-box">
        <div class="adv-top hz-icon"></div>
        <div class="adv-main">
          <div class="ys-main">
            <ul>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
      <fi-footer-mobile></fi-footer-mobile>
      <!-- :is-show="isShow" @hidemark="hideMarkHandle($event)" -->
      <fi-mark :is-mark="oMark"></fi-mark>
    </div>
    <div v-if="isBepoint">
      <iframe src="https://one.zhongan.com/fcp/fdyx/index.htm" class="fdyx"></iframe>
    </div>
  </div>
</template>
<script>
  import 'swiper/dist/css/swiper.css'
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import {
    os
  } from '../utils/tool'
  import FiMark from '../components/fimark'
  import FiFooterMobile from '../components/footerMobile'
  import FiHeaderMobile from '../components/headerMobile'

  export default {
    components: {
      swiper,
      swiperSlide,
      FiMark,
      FiFooterMobile,
      FiHeaderMobile
    },
    data() {
      const _vue = this;
      return {
        isPc: false,
        isMobile: false,
        isShow:false,
        oMark:{
          show:false
        },
        isDianDianHome:false,
        isBepoint:false,
        swiperOption: {
          // direction: 'vertical',
          // mousewheel: true,
          // parallax: true,
          // touchRatio: 0.5,
          // resistanceRatio: 0,
          speed: 450,
          height: 420,
          autoplay: {
            delay: 4000
          },
          loop: false,
          // effect: 'fade',
          // allowTouchMove: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          on: {
            slideChange: function(e) {

              // console.log(nowActiveIndex, this.activeIndex, 'index');
            },
            transitionEnd: function() {
              if (_vue.swiperOption.autoplay) {
                this.autoplay.start()
              }
            }
          }
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted() {
      if(window.location.host=='www.bepoint.cn'){
        document.title = '深圳蜂点科技有限公司';
        this.isBepoint=true
      }else{
        //点点
        document.title='点点_点点app_点点官网'
        this.isDianDianHome=true
      }
    },
    methods: {
      hideMarkHandle(val){
        this.isShow=val
      },
      downloadMobile() {
        var u = window.navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        console.log(u, isAndroid, isIOS);
        this.isLoading = true;

        //其他浏览器
        if (isIOS) {
          //com.baidu.tieba:// //ios app协议
          window.location.href = "zldd://main";
          setTimeout(() => {
            this.isLoading = false
            window.location.href = "https://apps.apple.com/cn/app/%E6%8D%A1%E5%AF%8C%E5%AE%9D/id1466062624?from=singlemessage&isappinstalled=0";
          }, 1000)
        } else if (isAndroid) {
          //微信
          if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
            // alert('weixin')
            // this.isLoading = false;
            // this.isWxMark = true;
            window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhonglian.diandian";
            return
          }
          window.location.href = "zldd://main";
          setTimeout(() => {
            this.isLoading = false
            window.location.href = this.diandianAndroidDownLoadUrl;
          }, 1000)
        }

      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// flatindexmobile2.vue?2a9cc4b6